import React from "react";
import appConfig from "../../../config/app.config";


const staticAssetsUrl = appConfig.staticAssetsUrl;

const ContentApiCardSection = () => {
    return (
        <div >
            <h2 className="text-xl font-bold">4.API Card Section</h2>
            <p>This section shows specific set of APIs based on selected product. You can click on any API Card to navigate to specific API details page.</p>
            <img className="pic" src={staticAssetsUrl + "user_manual/api_card_section.png"} />
        </div>
    )
}

export default ContentApiCardSection;
